export default __webpack_public_path__ + "static/media/Error.6d9d9cf7.svg";